import React from "react";

export default function Marquee() {
  const items = [
    "RASKT HJEM AS",
    "TRYGG FLYTTING",
    "STAVANGER",
    "FORSIKRET",
    "VARETRANSPORT",
    "FASTPRIS",
    "BORTKJØRING",
    "MONTERING",
    "ROGALAND",
  ];
  const loop = [...items, ...items];
  return (
    <div className="marquee-wrap bg-black border-y-2 border-black" data-testid="marquee-bar">
      <div className="marquee-track py-3">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <span className="font-display text-white text-xl md:text-2xl tracking-wider whitespace-nowrap">
              {t}
            </span>
            <span className="text-[#E11D2E] text-2xl">◆</span>
          </div>
        ))}
      </div>
    </div>
  );
}
